import { createFileRoute } from '@tanstack/react-router';

import { approvalsCreditNoteScreen, creditNoteApprovalsSearch, loadApprovalsCreditNoteScreen, loadApprovalsMessages } from '@/modules/approvals/route';
import { lazyScreen } from '@/shared/screen';

// Mesmo caminho do legado (router.tsx:727-731): sem aba no hub, só por URL, com `PendingApprovals:Read` e raiz pela
// trilha do hub (R6, A1 = migrar).
export const Route = createFileRoute('/_app/aprovacoes/gestao-aprovacoes/operacoes')({
  validateSearch: creditNoteApprovalsSearch,
  staticData: { screen: approvalsCreditNoteScreen },
  loader: () => loadApprovalsMessages(),
  component: lazyScreen(loadApprovalsCreditNoteScreen, 'ApprovalsCreditNoteScreen'),
});
